import { StyledButton } from "components/button.styles";
import styled from "@emotion/styled";

interface ColProps {
  $flex: 0 | 1;
}

export const StyledCol = styled.div<ColProps>`
  flex: ${(props) => props.$flex};
  position: relative;
  display: flex;

  &:last-of-type ${StyledButton} {
    margin-right: 0;
  }
`;
